const loadedScripts = new Set();

/**
 * Dynamically loads an external script into the DOM.
 * @param {string} src - URL of the script to load.
 * @param {Object} [options] - Optional loading settings.
 * @param {boolean} [options.async=true] - Whether to load asynchronously.
 * @param {boolean} [options.defer=false] - Whether to defer execution.
 * @returns {Promise<void>} - Resolves when the script is loaded.
 */
function loadScript(src, { async = true, defer = false } = {}) {
    return new Promise((resolve, reject) => {
        if (!src) {
            reject(new Error('src is required'));
            return;
        }

        if (loadedScripts.has(src)) {
            resolve();
            return;
        }
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        if (async) script.async = true;
        if (defer) script.defer = true;

        script.onload = () => {
            loadedScripts.add(src);
            resolve();
        };

        script.onerror = () => reject(
            new Error(`Failed to load script: ${src}`)
        );

        document.head.appendChild(script);
    });
}

module.exports = { loadScript };
